import { Injectable, inject } from '@angular/core';
import { Observable, tap, catchError, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse  } from '@angular/common/http';
import { appsettings } from '../settings/appsettings';

@Injectable({
  providedIn: 'root'
})
export class EvaluacionEtService {

  constructor() { }

  private http = inject(HttpClient);
  private url = appsettings.apiUrl;


  listarOrganizaciones(id_estado: string): Observable<any> {
    const url = `${this.url}/calculo-et/listar_organizaciones/${id_estado}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

  listarEstudiantes(id_estado: string): Observable<any> {
    const url = `${this.url}/estudiante/listar_estudiantes/${id_estado}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }

  calculoCuota(id_organizacion: string): Observable<any> {
    const url = `${this.url}/calculo-et/empresa/${id_organizacion}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }


  guardarCalculo(objeto: object):Observable<any>{
    const url = `${this.url}/calculo-et/guardar_calculo`; // URL completa en una variable para claridad
    return this.http.post<any>(url, objeto).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }


  listarEstudioCumplimiento(id_estado: string, tipo: string): Observable<any> {
    const url = `${this.url}/calculo-et/listar_estudio_cumplimiento/${id_estado}/${tipo}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }


  imprimir(id_organizacion: string): Observable<any> {
    const url = `${this.url}/calculo-et/imprimir_cumplimiento/${id_organizacion}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }


  borrarDocumento(id_organizacion: string): Observable<any> {
    const url = `${this.url}/calculo-et/borrar_planilla_cumplimiento/${id_organizacion}`; // URL completa en una variable para claridad
    return this.http.get<any>(url).pipe(
      tap((rs) => {
        // Opcional: Puedes usar tap para registrar información sobre la respuesta
        // console.log('Respuesta de la API:', response);
      }),
      catchError((error: HttpErrorResponse) => { // Manejo de errores
        console.error('Error en la solicitud:', error); // Registro del error en la consola
        let errorMessage = 'Ha ocurrido un error en la solicitud.'; // Mensaje genérico
        if (error.error) {
          // El error proviene del backend (por ejemplo, validación)
          errorMessage = error.error.message || errorMessage; // Intenta obtener un mensaje más específico
        } else if (error.status) {
          // El error es del cliente o de la red
          errorMessage = `Error ${error.status}: ${error.statusText}`; // Mensaje con código y texto de estado
        }
        return throwError(() => new Error(errorMessage)); // Propaga el error para que el componente lo maneje
      })
    );
  }



}
